// export DsfFormPickUp from './formPickUp.vue'

export const DsfFormPickUp = dsf.defineAsyncComponent("DsfFormPickUp", () =>
  import(/* webpackChunkName: "platform_pc_other" */ "./formPickUp.vue")
);
